export const BaseUrl = 'https://api.poll.dev-mn.xyz/api/'
export const BaseurlImage = 'https://api.poll.dev-mn.xyz/'